import styled from 'styled-components';
import defaultTheme from '../../theme';

const MultiOptionElement = styled.button`
  display: flex !important;
  justify-content: flex-start;
  align-items: center;
  background: ${props => (props.style.backgroundColor)};
  border: 1px ${props => (props.style.borderColor)} solid;
  border-radius: 8px;
  color: ${props => (props.style.color)};
  display: block;
  font-size: 14px;
  padding: 12px;
  font-weight: 400;
  width: 97%;
`;

MultiOptionElement.defaultProps = {
  theme: defaultTheme
};

export default MultiOptionElement;
